import { render, staticRenderFns } from "./PengajuanUjian.vue?vue&type=template&id=53c74898&"
import script from "./PengajuanUjian.vue?vue&type=script&lang=js&"
export * from "./PengajuanUjian.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanUjian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports